import { Button } from "reactstrap";
import { AsyncButton } from "../../common/buttons";
import { SEPARATOR_BORDER } from "./wizardStyles";

export default function WizardBottomNav({
  onBack,
  onNext,
  onSkip,
  skipLabel = "Skip",
  isFirst,
  isLast,
  nextDisabled,
  nextHelp,
  nextButton,
}) {
  return (
    <div
      className="d-flex justify-content-between align-items-center mt-4 pt-3"
      style={{ borderTop: SEPARATOR_BORDER }}
    >
      <div>
        {!isFirst && (
          <Button color="secondary" outline onClick={onBack}>
            <i className="fas fa-arrow-left mr-2" />
            Back
          </Button>
        )}
      </div>
      <div className="d-flex align-items-center" style={{ gap: "0.75rem" }}>
        {nextHelp && <small className="text-muted">{nextHelp}</small>}
        {onSkip && !isLast && (
          <AsyncButton color="secondary" outline onClick={onSkip}>
            {skipLabel}
            <i className="fas fa-forward ml-2" />
          </AsyncButton>
        )}
        {!isLast &&
          (nextButton ?? (
            <AsyncButton color="primary" onClick={onNext} disabled={nextDisabled}>
              Next
              <i className="fas fa-arrow-right ml-2" />
            </AsyncButton>
          ))}
      </div>
    </div>
  );
}
